import { render, staticRenderFns } from "./ClientServiceLog.vue?vue&type=template&id=56889c32&scoped=true&"
import script from "./ClientServiceLog.vue?vue&type=script&lang=js&"
export * from "./ClientServiceLog.vue?vue&type=script&lang=js&"
import style0 from "./ClientServiceLog.vue?vue&type=style&index=0&id=56889c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56889c32",
  null
  
)

export default component.exports